/**
 * @generated SignedSource<<a14fc4553c7abb7a8635a5d67637e33d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveClientMetricInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type ClientBodyWeightDrawerRemoveClientMetricMutation$variables = {
  input: RemoveClientMetricInput;
};
export type ClientBodyWeightDrawerRemoveClientMetricMutation$data = {
  readonly removeClientMetric: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type ClientBodyWeightDrawerRemoveClientMetricMutation = {
  response: ClientBodyWeightDrawerRemoveClientMetricMutation$data;
  variables: ClientBodyWeightDrawerRemoveClientMetricMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveClientMetricPayload",
    "kind": "LinkedField",
    "name": "removeClientMetric",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientBodyWeightDrawerRemoveClientMetricMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientBodyWeightDrawerRemoveClientMetricMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca934cea442358896092698e4e992436",
    "id": null,
    "metadata": {},
    "name": "ClientBodyWeightDrawerRemoveClientMetricMutation",
    "operationKind": "mutation",
    "text": "mutation ClientBodyWeightDrawerRemoveClientMetricMutation(\n  $input: RemoveClientMetricInput!\n) {\n  removeClientMetric(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc3f64b6042d31c7cecd221d634d988f";

export default node;
